import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=c4c46902"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=c4c46902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports